import { AuthGuard } from './auth.guard';

export const guards: any[] = [AuthGuard];

export * from './auth.guard';
